<template>
  <section id="my-donations-section" class="section-scc-portal container">
    <form id="form-my-donations-portal-scc" v-if="loadPage">
      <div class="row container-block items-row-my-donations">
        <div class="col-md-6 ">
          <h2 id="your-blood-my-donation">
            Your Blood Type:
            <span id="blood-type"> {{ bloodType }}</span>
          </h2>
        </div>
      </div>
      <div class="container-item-tabl container-block">
        <h3 class="" v-if="donorEligibilityPage.length!==0">You are currently eligible to donate:</h3>
        <div class="row" id="block-link-donate-blood container-block">
          <div
              class="col-sm-12 col-md-6 col-lg-3 container_eligibility"
              v-for="(lineEligibility, indexEligibility) in donorEligibilityPage"
              :key="indexEligibility"
          >
            <a
                href="#"
                style="font-size: 20px"
                v-on:click.prevent="eligibilityMethods(lineEligibility)"
            >
              {{lineEligibility.eligibilityNameProcedure}} ({{ lineEligibility.eligibilityDate}})
            </a>
          </div>
        </div>
      </div>
      <div class="container-item-tabl container-block" v-if="donorCharacteristicsPage.length!==0">
        <div
            class="container-block"
            v-for = "(itemDonorCharacteristics, indexDonorCharacteristics) in  donorCharacteristicsPage"
            :key = 'indexDonorCharacteristics'
        >
          <h3>{{ itemDonorCharacteristics.name }} {{ itemDonorCharacteristics.date }}</h3>
        </div>
      </div>
      <div class="container-item-tabl container-block" v-if="futureDonationsPage.length!==0">
<!--      <div class="container-item-tabl container-block" v-if="futureDonations.length!==0"> -->
        <h3>Your Scheduled Appointments</h3>
        <div>
          <table
              class="table table-bordered table-hover"
          >
            <thead>
            <tr  class="adapt-tr adapt-tr-head">
              <th scope = "col" class="tab-title-center adapt-th">Reschedule/Cancel</th>
              <th scope = "col" class="tab-title-center adapt-th">Date</th>
              <th scope = "col" class="tab-title-center adapt-th">Time</th>
              <th scope = "col" class="tab-title-center adapt-th">Name</th>
              <th scope = "col" class="tab-title-center adapt-th">Type</th>
            </tr>
            </thead>
            <tbody>
              <tr
                  class="adapt-tr"
                  v-for="itemFutureDonations in futureDonationsPage"
                  :key = "itemFutureDonations.idDonation"
              >
                <td class="button-future-app adapt-td" scope="row" style="text-align: start;">
<!--                  <img class="fa hover-pointer" :src="urlIcon" style="height: 30px; " v-on:click="rescheduleAppointment(itemFutureDonations.idDonation)"> -->
                  <div class="row">
                    <div
                        class="col"
                        style="display:flex;justify-content:center;"
                        v-on:click = "rescheduleAppointment(itemFutureDonations.idDonation /*'<?php echo $row_appointments['id'];?>'*/)"
                    >
                      <img
                          :src="urlIcon.rescheduleAppointmentButton"
                          id="reschedule-appointment-button"
                          class="update-future-app fa"
                          style="height: 30px;  "
                      />
                      <b-tooltip target="reschedule-appointment-button" triggers="hover">
                        Reschedule
                      </b-tooltip>
                    </div>
                    <div

                        class="col" style="display:flex;justify-content:center;"
                        v-on:click = "cancelAppointment(itemFutureDonations.idDonation /*'<?php echo $row_appointments['id'];?>'*/)"
                    >
                      <img
                          :src="urlIcon.cancelAppointmentButton"
                          id="cancel-appointment-button"
                          class="delete-future-app fa"
                          style="height: 30px; "
                      />
                      <b-tooltip target="cancel-appointment-button" triggers="hover">
                        Cancel
                      </b-tooltip>
                    </div>
                  </div>
                </td>
                <td class="adapt-td">{{ itemFutureDonations.dateStartDay }}</td>
                <td class="adapt-td">
                  {{
                    itemFutureDonations.status === 'Walk-in'
                    ? 'Walk-in - ' + itemFutureDonations.approxTime
                    : itemFutureDonations.dateStartTime
                  }}
                </td>
                <td class="adapt-td">{{ itemFutureDonations.locationDonation }}</td>
                <td class="adapt-td">{{ itemFutureDonations.procedureType }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h3 v-else>No Scheduled Appointments</h3>
      <div class="row container-item-form " style="text-align: center">
        <button
            type="button"
            class="button-section btn"
            id="btn-schedule"
            v-on:click="$router.push({name: 'donateBlood'})"
        >
          SCHEDULE APPOINTMENT
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapState } from "vuex"
import moment from "moment-timezone"
export default {
  name: "myDonations",
  data(){
    return{
      loadPage: false,
      bloodTypePage: '',
      donorCharacteristicsPage: [],
      futureDonationsPage: [],
      donorEligibilityPage: [],
      urlIcon: {
        rescheduleAppointmentButton: '#',
        cancelAppointmentButton: '#',
      },
    }
  },
  computed : {
    ...mapState({
      urlPortal: state => state.settingsAndCustomize.configurationSite.urlSite,
      bloodType: state => state.donorInformation.bloodType,
      donorCharacteristics: state => state.donorInformation.donorCharacteristics,
      donorEligibility: state => state.donorInformation.donorEligibility,
    }),
  },
  watch:{
    futureDonations(val){
      this.futureDonationsPage = val
    },
  },
  async created() {
    await this.updateData()

    this.urlIcon.rescheduleAppointmentButton = this.urlPortal + 'img/system/portalIcons/reschedule_appointment_' + this.$store.getters["settingsAndCustomize/hash"] + '.png'
    this.urlIcon.cancelAppointmentButton = this.urlPortal + 'img/system/portalIcons/delete_appointment_' + this.$store.getters["settingsAndCustomize/hash"] + '.png'

    this.loadPage = true
  },
  methods: {
    async updateData(){
      this.bloodTypePage = this.bloodType

      this.$root.$emit("showSpinner")
      this.futureDonationsPage = await this.$store.dispatch('donorInformation/SET_donorFutureDonate')

      await this.$store.dispatch('donorInformation/SET_donorGetCharacteristics')
      await this.$store.dispatch('donorInformation/SET_donorEligibility')


      this.donorCharacteristicsPage = this.donorCharacteristics

      for (let i=0; i<this.donorCharacteristics.length; ++i  ){
        this.donorCharacteristicsPage[i].date = moment(this.donorCharacteristics.length[i].date).format('MM/DD/YYYY')
      }

      this.donorEligibilityPage = this.donorEligibility
      this.$root.$emit("hideSpinner")
    },
    eligibilityMethods(lineEligibility){
      if (lineEligibility.eligibilityStatus === 'NOT_ELIGIBLE'){
        this.errorAlert('You are not eligible to donate ' + lineEligibility.eligibilityNameProcedure + '. Please call the donor room, if you have questions about your eligibility.')
        return
      }
      let strElig = '',
          strNameProcedure = '',
          strDateEligibility = lineEligibility.eligibilityDate !== '' ? moment(lineEligibility.eligibilityDate).format("YYYY-MM-DD") : '';

      strElig = strDateEligibility +'|'
          + lineEligibility.eligibilityCodeProcedure + '|'
          + lineEligibility.eligibilityProcedureClass + '|'
          + lineEligibility.eligibilityProcedureType
      strNameProcedure = lineEligibility.eligibilityNameProcedure

      this.$router.push({
        name: 'dbChoiceDonationLocation',
        query: {
          elig: strElig,
          procedureName: strNameProcedure,
        }
      })
    },
    async cancelAppointment(idApp){

      if (!confirm('Are you sure you want to cancel your appointment?')) {
        return
      }
      var dataDelete = {
        action: 'entryPoints',
        entryPoint: 'appointment_calendar',
        entryAction: 'deleteAppointment',
        apptId: idApp,
        mode: 'cancel',
      }
      this.$root.$emit("showSpinner")

      const resultDelete = await this.$store.dispatch('pages/SET_entryPoint', dataDelete)
      this.$root.$emit("hideSpinner")

      if (resultDelete?.data !== null && resultDelete?.data !== '') {
        this.successMessages('Your appointment has been cancelled.');
        this.$root.$emit("showSpinner")
        await this.updateData()
        this.$root.$emit("hideSpinner")
      } else {
        this.errorAlert('We were unable to delete your appointment. Contact the coordinator.');
      }
    },
    rescheduleAppointment(idApp){
      this.$router.push( {name: 'dbChoiceDonationLocation', query:{idApp: idApp}})
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
    successMessages(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 2000,
          typeColor: "success",
          textMessage: message,
        })
    },
  }
}
</script>

<style scoped>

.container-block{
  margin-bottom: 20px;
}
#your-blood-my-donation{
  display: flex;
  align-items: center;
}
#blood-type{
  font-size: 40px;
  color: #D90000;
  margin-left: 10px;
}
.container_eligibility{
  border: 1px solid #000;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container_eligibility a{
  text-decoration: none;
  background-color: transparent;
  color: inherit;
}
.container_eligibility a:hover{
  color: var(--ButtonColor);
  text-decoration: underline;
}
</style>
